import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X, Sparkles } from 'lucide-react';
import './DashModal.css';

export default function DashModal({ open, title, subtitle, onClose, children, wide, medium, fill, keepMounted }) {
  const [vh, setVh] = useState(window.innerHeight * 0.94);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  useEffect(() => {
    const onResize = () => setVh(window.innerHeight * 0.94);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (!open && !keepMounted) return null;

  return createPortal(
    <div className="dash-modal-root" role="presentation" style={open ? undefined : { display: 'none' }}>
      <button type="button" className="dash-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div
        className={`dash-modal${wide ? ' dash-modal--wide' : ''}${medium ? ' dash-modal--medium' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={{ maxHeight: Math.min(920, vh), ...(fill ? { height: Math.min(920, vh) } : {}) }}
      >
        <header className="dash-modal-banner">
          <div className="dash-modal-banner-glow" aria-hidden="true" />
          <div className="dash-modal-banner-content">
            <span className="dash-modal-eyebrow">
              <Sparkles size={14} />
              Tarjemlek
            </span>
            <h3>{title}</h3>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          <button type="button" className="dash-modal-close" onClick={onClose} aria-label="Close">
            <X size={18} />
          </button>
        </header>
        <div className={fill ? 'dash-modal-body dash-modal-body--fill' : 'dash-modal-body'}>{children}</div>
      </div>
    </div>,
    document.body,
  );
}
